module.exports = __webpack_public_path__ + "static/media/Third-Floor.7bb820ea.png";